RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const Summary = Marionette.ItemView.extend({
        template: '#notificationSettingSectionSummaryTemplate',
        modelEvents: {
            'change:scheduledDay': 'render',
            'change:scheduledHour': 'render'
        },

        getSummary: function () {
            const me = this;
            const frequency = me.model.get('frequency');
            const emailTypeName = RivalIQ.enums.email.details[me.model.get('group')].description;
            const scheduledDay = me.model.get('scheduledDay');
            const scheduledHour = me.model.get('scheduledHour');
            const landscapeName = _.find(RivalIQ.state.user.get('landscapes'), function (landscape) {
                return landscape.id === RivalIQ.state.landscape.id;
            }).name;

            const timezone = RivalIQ.state.landscape.get('timezone') || 'UTC';

            // NOTE this scheduled time and other time text that appear are purely for display, so keep it UTC
            const scheduledTime = moment.utc().day(scheduledDay).hour(scheduledHour).minutes(0);
            return `Deliver <strong>${frequency.toLowerCase()}</strong> ${emailTypeName} emails to the ${
                landscapeName} Landscape on <strong>${scheduledTime.format('dddd')}s</strong> at <strong>${
                RivalIQ.utils.timezone.formatHour(scheduledHour, timezone)}</strong>`;
        },

        templateHelpers: function () {
            const me = this;

            return {
                summary: me.getSummary()
            };
        }
    });

    views.EditScheduleModal = Marionette.LayoutView.extend({
        template: '#notificationSettingSectionEditScheduleModalTemplate',

        regions: {
            summary: '.x-summary-region'
        },

        ui: {
            modal: '.modal',
            infoBubbles: '.fa-info-circle',
            selectedTimeLabel: '.current-selected-time',
            selectedDayLabel: '.current-selected-day',
            saveBtn: '.x-save-btn'
        },

        events: {
            'click @ui.saveBtn': 'onSaveClick',
            'click .dropdown-select-day': 'onDaySelect',
            'click .dropdown-select-time': 'onTimeSelect'
        },

        onBeforeShow: function () {
            const me = this;
            me.ui.infoBubbles.popover();
            me.setDefaults();
            me.showSummary();
        },

        setDefaults: function () {
            const me = this;
            const defaultLocalizedRuntime = me.options.getDefaultLocalizedRuntime();
            me.ui.selectedDayLabel.text(`${moment.utc().day(defaultLocalizedRuntime.day()).format('dddd')}s`);

            const timezone = RivalIQ.state.landscape.get('timezone') || 'UTC';

            me.ui.selectedTimeLabel.text(RivalIQ.utils.timezone.formatHour(defaultLocalizedRuntime.hour(), timezone));
            // model's scheduleDay & hour should always be in local, user time
            me.model.set({
                scheduledDay: defaultLocalizedRuntime.day(),
                scheduledHour: defaultLocalizedRuntime.hour()
            });
        },

        showSummary: function () {
            const me = this;

            me.summary.show(new Summary({
                model: me.model
            }));
        },

        templateHelpers: function () {
            const me = this;
            const emailTypeName = RivalIQ.enums.email.details[me.model.get('group')].description;

            return {
                timesList: me.getTimesList(),
                daysList: me.getDaysList(),
                emailType: emailTypeName
            };
        },

        getDaysList: function () {
            return _.map(_.range(7), function (i) {
                return {
                    // utc makes it so that 0 always means Sunday
                    label: `${moment.utc().day(i).format('dddd')}s`,
                    value: i
                };
            });
        },

        getTimesList: function () {

            const clientTimeZone = RivalIQ.state.landscape.get('timezone') || 'UTC';

            return _.map(_.range(24), function (i) {
                return {
                    label: RivalIQ.utils.timezone.formatHour(i, clientTimeZone),
                    value: i
                };
            });
        },

        onSaveClick: function () {
            const me = this;
            const emailsGroup = me.model.get('group');
            const landscape = RivalIQ.state.landscape;
            const groupScheduledAlertsRunInfo = landscape.get('scheduledAlertsRunInfo')[me.model.get('group')];
            const localScheduledDay = me.model.get('scheduledDay');
            const localScheduledHour = me.model.get('scheduledHour');

            me.ui.saveBtn.button('loading');

            // update the schedule with utc equivalents
            const timezone = RivalIQ.state.landscape.get('timezone') || 'UTC';

            const timeInUTC = moment.utc().day(localScheduledDay).hour(localScheduledHour).minutes(0).seconds(0);
            const offsetMinutes = RivalIQ.utils.timezone.getTimeZoneOffsetMinutes(timezone, new Date());
            let closestUtcRuntime = timeInUTC.subtract(offsetMinutes, 'minutes');

            const updatedAlertEmailSchedule = {};
            updatedAlertEmailSchedule[emailsGroup] = {
                day: closestUtcRuntime.day(),
                hour: closestUtcRuntime.hour()
            };

            // also update the next run date (in utc) to match new schedule
            const updatedRunInfo = {};
            const utcNow = moment.utc();
            if (closestUtcRuntime.isBefore(utcNow)) {
                closestUtcRuntime = closestUtcRuntime.add(1, 'week');
            }
            updatedRunInfo[emailsGroup] = _.extend(groupScheduledAlertsRunInfo, {
                next_run_after: closestUtcRuntime.format()
            });

            RivalIQ.state.landscape.set({
                alertEmailSchedule: _.extend(landscape.get('alertEmailSchedule'), updatedAlertEmailSchedule),
                scheduledAlertsRunInfo: _.extend(landscape.get('scheduledAlertsRunInfo'), updatedRunInfo)
            });

            me.ui.modal.modal('hide');
            RivalIQ.execute('alert:info', 'Schedule saved!');
        },

        onDaySelect: function (e) {
            const me = this;
            const $el = $(e.currentTarget);
            me.ui.selectedDayLabel.text($el.text());
            me.model.set({
                scheduledDay: $el.attr('value')
            });
        },

        onTimeSelect: function (e) {
            const me = this;
            const $el = $(e.currentTarget);
            me.ui.selectedTimeLabel.text($el.text());
            me.model.set({
                scheduledHour: $el.attr('value')
            });
        }
    });

    views.SettingSection = RivalIQ.views.LayoutView.extend({
        className: 'section-setting',
        template: '#notificationSettingSectionTemplate',

        regions: {
            configBtn: '.x-edit-config-btn'
        },

        events: {
            'click .x-edit-schedule': 'onEditScheduleClick'
        },

        loadData: function () {
            return $.when.call();
        },

        isSchedulableEmailGroup: function () {
            const me = this;
            return _.includes(RivalIQ.enums.email.schedulableGroups, me.model.get('group'));
        },

        isWeeklyUpdatesSection: function () {
            const me = this;
            return me.model.get('section') === RivalIQ.enums.email.section.weeklyUpdates;
        },

        getDefaultLocalizedRuntime: function () {
            const me = this;
            const emailGroup = me.model.get('group');

            const clientTimeZone = RivalIQ.state.landscape.get('timezone') || 'UTC';
            const utcSchedule = _.get(RivalIQ.state.landscape.get('alertEmailSchedule'), [emailGroup]) || me.model.get('defaultSchedule');
            return moment.tz(moment.utc().day(utcSchedule.day).hour(utcSchedule.hour), clientTimeZone);
        },

        getScheduledFrequency: function () {
            const me = this;
            const frequency = me.model.get('frequency');

            if (me.isSchedulableEmailGroup()) {
                const localizedRuntime = me.getDefaultLocalizedRuntime();
                const timezone = RivalIQ.state.landscape.get('timezone') || 'UTC';

                return `${frequency} on ${localizedRuntime.format('dddd')}s at ${RivalIQ.utils.timezone.formatHour(localizedRuntime.hour(), timezone)}`;
            }
            return frequency;
        },

        templateHelpers: function () {
            const me = this;

            return {
                schedulable: me.isSchedulableEmailGroup(),
                isWeeklyUpdatesSection: me.isWeeklyUpdatesSection(),
                scheduledFrequency: me.getScheduledFrequency()
            };
        },

        onEditScheduleClick: function () {
            const me = this;
            const modal = new views.EditScheduleModal({
                model: new Backbone.Model({
                    frequency: me.model.get('frequency'),
                    group: me.model.get('group'),
                    defaultSchedule: me.model.get('defaultSchedule')
                }),
                getDefaultLocalizedRuntime: me.getDefaultLocalizedRuntime
            });

            me.listenTo(RivalIQ.state.landscape, 'change:alertEmailSchedule', me.render);

            App.execute('show:modal', modal);
        }
    });

    views.Setting = views.SettingSection.extend({
        behaviors: {
            Information: {
                behaviorClass: RivalIQ.behaviors.Information
            }
        },
        regions: {},
        ui: {
            checkbox: 'input',
            checkboxLabel: '.alert-checkbox-label',
            spinner: '.fa.fa-spin',
            success: '.text-success'
        },
        eventsNotToDebounce: {
            'change input': 'updateSetting'
        },
        className: 'setting-item flex',
        template: '#notificationSettingTemplate',

        updateSetting: function () {
            const me = this;

            me.ui.checkbox.attr('disabled', true);
            me.ui.success.hide();
            me.ui.spinner.show();

            const dashboardEmailTypeId = me.model.get('dashboardEmailTypeId');
            const isEnabled = me.ui.checkbox.is(':checked');

            RivalIQ.state.user.setEmailSetting(dashboardEmailTypeId, isEnabled);
            me.model.set({
                enabled: isEnabled
            }, {
                silent: true
            });

            me.listenTo(RivalIQ.state.user, 'persisted:emailSettings', me.onSettingPersisted);
        },

        onSettingPersisted: function () {
            const me = this;
            me.ui.checkbox.attr('disabled', false);
            me.ui.spinner.hide();
            me.ui.success.show();
        }
    });
}, window.moment);
